interface SkeletonProps {
	className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps) {
	return (
		<div
			className={`skeleton-sheen rounded-card bg-surface-2/60 ${className}`}
			aria-hidden="true"
		/>
	);
}

/** Skeleton đúng tỉ lệ thẻ phim để lưới không bị giật khi dữ liệu về. */
export function AnimeCardSkeleton() {
	return (
		<div className="min-w-0">
			<Skeleton className="aspect-[2/2.8] w-full" />
			<Skeleton className="mt-2.5 h-3.5 w-4/5" />
			<Skeleton className="mt-2 h-3 w-1/2" />
		</div>
	);
}

export function AnimeGridSkeleton({ count = 12 }: { count?: number }) {
	return (
		<div className="grid grid-cols-2 gap-4 min-[700px]:grid-cols-4 min-[1100px]:grid-cols-6">
			{Array.from({ length: count }, (_, index) => (
				<AnimeCardSkeleton key={index} />
			))}
		</div>
	);
}

export function EpisodeListSkeleton({ count = 8 }: { count?: number }) {
	return (
		<div className="grid gap-3.5 min-[700px]:grid-cols-2 min-[1100px]:grid-cols-4">
			{Array.from({ length: count }, (_, index) => (
				<Skeleton key={index} className="h-[81px] w-full rounded-card" />
			))}
		</div>
	);
}
